import i18n from 'shared/lib/i18n';

export const XLSX_ERROR = () => i18n.t('errors.xlsxError');
